import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import ReactEcharts from "echarts-for-react";
import { barChart } from "../widgets/Charts";
import Helpers, { windowsActive } from "../../../../config/Helpers";
import axios from "axios";

const postUrlLogin = API_URL + "widgets";

class FutureReserves extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            array_colors : ["#fec400", "#ff7d4d", "#ff4558", "#15d39a"],
            table_result : {
                years : (<div></div>),
                months : (<div></div>),
                list : (<div></div>)
            }
        }
        this.getOptionTypeBar   = this.getOptionTypeBar.bind(this);
    }

    getOptionTypeBar = (chart) => {
        
        let char_keys = Object.keys(this.props.response_request);
        let legends = [], xAxis = [], series = [];
        let $self = this;
        let result
        if (char_keys.length > 0){
            result    = this.props.response_request["result"][chart];
            if(chart !== "data_adv_booking_intervals"){
                Object.keys(result).map(function(key){
                switch (key) {
                    case "legends":
                        legends = result[key];
                        break;
                
                    case "xAxis":
                        xAxis = result[key];
                        break;
                    
                    case "series":
                        series = Object.keys(result[key]).map(function(key_serie, index){
                            return {
                                name: key_serie,
                                color: $self.state.array_colors[index],
                                type: "bar",
                                data: result[key][key_serie]
                            }
                        })
                        break;
                    }
                })
            }
        }
        return barChart("auto", legends, xAxis, series, $self.props.view_results, this.props.current_year, this.props.past_year)
    }
    componentWillReceiveProps(props){
        let char_keys = Object.keys(this.props.response_request);
        let $self = this;
        let result
        let type_value = this.props.view_results !== "room_night" ? "$" : "";
        if (char_keys.length > 0){
            result  = this.props.response_request["result"]["data_reserves_to_future"];
            this.state.table_result.years = Object.keys(result["legends"]).map( (key_serie, index) =>
                <div className={"column-grid " + (index % 2 ? "row-c" : "")}>
                    <div className="row-grid">{result["legends"][key_serie]}</div>
                </div>
            );
            this.state.table_result.months = Object.keys(result["xAxis"]).map( (key_serie) =>
                <span className="row-grid to-future">{result["xAxis"][key_serie]}</span>
            );
            this.state.table_result.list = Object.keys(result["data_table"]).map( (key_serie, index) =>  
                <div className={"column-grid " + (index % 2 ? "row-c" : "")}>
                    { 
                        result["data_table"][key_serie].map( (tariff) =>
                            <div className="row-grid to-future">{type_value + tariff}</div>
                        ) 
                    }
                </div>
            );
        }
    }
    render() {
        return (
            <section>
                <div className={"datagrid-widget reserves-to-future"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">ADVANCE BOOKING</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                <ReactEcharts
                                    option={ windowsActive(this.props, "lead-time", "future_reserves") === true ? this.getOptionTypeBar("data_reserves_to_future") : {}}
                                    notMerge={true}
                                    lazyUpdate={true}
                                    theme={"theme_name"}
                                    opts={{renderer: 'svg'}}
                                    onChartReady={this.onChartReadyCallback}
                                />
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-2 no-padding-left-right">
                        <div className={"datagrid-widget list-years"}>
                            <div className="container-fluid no-padding-right">
                                <div className="row header-widget no-margin-left-right">
                                    <div className="col-md-12 options-widget no-padding-left-right">
                                        <span className="title year">YEAR</span>
                                        
                                    </div>
                                </div>
                                <div className="current-values">
                                    <div className="row no-margin-left-right">
                                        <div className="col-md-12 datagrid-list no-padding-left-right">
                                            {this.state.table_result.years}
                                        </div>
                                    </div>
                                </div>   
                            </div>
                        </div>
                    </div>
                    <div className="col-md-10 no-padding-left-right">
                        <div className="scroller-section">
                            <div className={"datagrid-widget list-result-years"}>
                                <div className="container-fluid no-padding-left-right">
                                    <div className="row header-widget no-margin-left-right">
                                        <div className="col-md-12 options-widget">
                                            <span className="title">ADVANCE BOOKING</span>
                                        </div>
                                    </div>
                                    <div className="current-values">
                                        <div className="row no-margin-left-right">
                                            <div className="col-md-12 head-current">
                                                {this.state.table_result.months}
                                            </div>
                                        </div>
                                        <div className="row no-margin-left-right">
                                            <div className="col-md-12 datagrid-list">
                                                {this.state.table_result.list}
                                            </div>
                                        </div>
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default FutureReserves



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/views/FutureReserves.js